const secretValue = '******';

export default secretValue;
